import React, {Component} from 'react';
import './AboutCard.css';
import {Link} from 'react-router-dom';

class CommunityAboutCard extends Component {
	render() {
		const {
			community: {
				name,
				profile: {uniqueName},
				location: {suburb} = {},
				category
			}
		} = this.props;

		return (
			<Link to={`/!${uniqueName}`} className="AboutCard">
				<div className="AboutCard-details">
					<div className="AboutCard-name">{name}</div>
					{category && <div className="AboutCard-profession">{category}</div>}
					<div className="AboutCard-geo">
						<span className="icon icon-room" />
						<span className="AboutCard-suburb">{suburb}</span>
					</div>
				</div>
			</Link>
		);
	}
}

export default CommunityAboutCard;



// WEBPACK FOOTER //
// ./src/profile/CommunityAboutCard.js